import { render, staticRenderFns } from "./export-question.vue?vue&type=template&id=f2bc532c&scoped=true"
import script from "./export-question.vue?vue&type=script&lang=js"
export * from "./export-question.vue?vue&type=script&lang=js"
import style0 from "./export-question.vue?vue&type=style&index=0&id=f2bc532c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bc532c",
  null
  
)

export default component.exports